var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4054 61.1177L76.4046 70.4293L67.1213 51.6966L71.917 40.9255C73.1291 38.777 75.1114 38.7486 76.3235 40.9255L86.4054 61.1177Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4088 70.4253L39 105.219L67.1256 51.6965L76.4088 70.4253Z",
    fill: "#F57F17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3712 46.8765C99.163 45.1699 101.007 45.7455 101.474 48.1697L111.199 104.749L78.9424 124.114C77.8114 124.747 74.8116 124.994 74.8116 124.994C74.8116 124.994 72.0833 124.662 71.0375 124.086L39 105.219L97.3712 46.8765Z",
    fill: "#FFCA28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1255 51.6965L39 105.219L51.5345 26.9884C52.0047 24.5642 53.379 24.3169 54.6194 26.4654L67.1255 51.6965Z",
    fill: "#FFA000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.89bc2005d0ccc2b4ba99925e9cc8adcf.svg";
export { ForwardRef as ReactComponent };